import { memo } from "react";
import { Box, Link, Typography } from "@mui/material";

const Footer = memo(({ sx = {} }) => {
  return (
    <Box
      sx={{
        height: "55px",
        display: "flex",
        flexDirection: "column",
        gap: "2px",
        justifyContent: "center",
        ...sx,
      }}
    >
      <Typography variant="caption" color={"rgb(0, 0, 0)"} fontWeight={900}>
        ©️ 2026{" "}
        <Link
          href="https://www.sicherheitsausbildung-berlin.de/"
          target="_blank"
        >
          sicherheitsausbildung-berlin.de
        </Link>{" "}
        . All Rights Reserved. |{" "}
        <Link
          href="https://www.sicherheitsausbildung-berlin.de/datenschutz"
          target="_blank"
        >
          Datenschutz
        </Link>{" "}
        |{" "}
        <Link
          href="https://www.sicherheitsausbildung-berlin.de/impressum"
          target="_blank"
        >
          Impressum
        </Link>
      </Typography>
    </Box>
  );
});

export default Footer;

//   <Typography variant="caption" color={"rgb(0, 0, 0)"} fontWeight={900}>
//     ❤️ Webdesign & Developed by{" "}
//     <Link href="https://pb-infotech.de/" target="_blank">
//       PB Infotech.
//     </Link>
//   </Typography>
